module.exports = {"type":"group","name":"summaryNodeSymbols","from":{"facet":{"name":"rawBreakdown","data":"summaryNodes","field":"partitions"}},"encode":{"update":{"x":{"field":"x"},"y":{"signal":"datum.y - (datum.multiplier || 1) * summaryBoxSize.height / 2"}}},"data":[],"marks":[]}


//////////////////
// WEBPACK FOOTER
// ./src/app/hsd-tree/sum-tree/vega-spec/marks/tree/summary-nodes/symbol-group/group.json
// module id = PHoP
// module chunks = 0